import {setSnackbarDispatch, SnackbarActionTypes} from "../context/SnackBarContext";
import {ServerErrorHandler} from "../service/errorHandler/ServerErrorHandler";


export class SnackbarHelper {

    constructor(snackbar) {
        this.snackbar = snackbar;
    }

    showSuccessMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_SUCCESS, message))
    }

    showErrorMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, message))
    }

    showWarningMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_WARNING, message))
    }

    showInfoMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_INFO, message))
    }

    showDefaultMessage(message = "") {
        this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_DEFAULT, message))
    }

    showServerErrorMessage(reason, defaultMessage = "") {
        let message = ""

        const _serverError = new ServerErrorHandler(reason)

        if (_serverError.getStatusCode() === 500) {
            message = "خطایی در سرور رخ داده است، لطفا به مدیر سیستم خود اطلاع دهید."
        } else if (_serverError.getStatusCode() === 403) {
            message = "دسترسی شما به این صفحه محدود شده است."

            window.location.href  = "/panel/403"
        } else {
            message = _serverError.getMessage(defaultMessage, reason)
        }


        if (message && message.length > 0)
            this.snackbar(setSnackbarDispatch(SnackbarActionTypes.SHOW_ERROR, message))
    }
}